import { ArrowRight, Play } from "lucide-react";

const HeroSection = () => {
  const scrollTo = (id: string) => {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="relative min-h-[105vh] md:min-h-[75vh] flex items-end md:items-center overflow-hidden">
      {/* Image Background */}
      <div className="absolute inset-0">
        <img
          src="/hero-768.webp"
          srcSet="/hero-768.webp 768w, /hero-1280.webp 1280w, /hero-1920.webp 1920w"
          sizes="100vw"
          alt="AdiStore varuautomat i modern kontorsmiljö"
          width={1920}
          height={1072}
          fetchPriority="high"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover object-[70%_50%] md:object-[60%_50%]"
        />
        {/* Dark overlays for readability */}
        <div className="absolute inset-0 bg-[hsl(216,60%,8%)]/10 md:bg-[hsl(216,60%,8%)]/20" />
        <div className="absolute inset-0 bg-gradient-to-r from-[hsl(216,60%,6%)]/60 via-[hsl(216,56%,12%)]/15 to-transparent md:from-[hsl(216,60%,6%)]/80 md:via-[hsl(216,56%,12%)]/25" />
        {/* Top gradient so logo and header stay readable on all screens */}
        <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[hsl(216,60%,6%)]/70 via-[hsl(216,60%,6%)]/25 to-transparent md:h-48 md:from-[hsl(216,60%,6%)]/75 md:via-[hsl(216,60%,6%)]/35" />
      </div>

      <div className="container relative mx-auto px-0 md:px-4 md:py-20 lg:py-0">
        <div className="w-full md:max-w-3xl md:mt-0 bg-gradient-to-t from-[hsl(216,60%,6%)]/95 via-[hsl(216,60%,6%)]/75 to-transparent md:bg-none px-4 pt-20 pb-10 md:p-0 backdrop-blur-[1px] md:backdrop-blur-0">
          <div>
            <span className="inline-block font-body text-xs font-bold uppercase tracking-[0.2em] text-accent mb-4">
              Varuautomater för företag
            </span>
            <h1 className="font-display text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-normal leading-[1.1] text-white mb-5">
              Varuautomater för företag{" "}
              <span className="italic text-accent">i Skåne</span>
            </h1>
          </div>

          <p className="font-body text-base md:text-lg text-white/90 mb-8 max-w-xl leading-relaxed font-light">
            Vi levererar och installerar pålitliga varuautomater till arbetsplatser i Malmö, Lund, Helsingborg och hela Skåne. Kompletta lösningar med kyld färdigmat, snacks och dryck anpassade efter era behov.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollTo("#produkter")}
              className="group flex items-center justify-center gap-3 rounded-full bg-accent px-8 py-4 text-base font-semibold text-accent-foreground hover:bg-orange-hover transition-all duration-300 shadow-xl shadow-accent/25 hover:shadow-accent/35 hover:scale-[1.02]"
            >
              Se våra automater
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => scrollTo("#tjanster")}
              className="group flex items-center justify-center gap-3 rounded-full border border-white/25 px-8 py-4 text-base font-semibold text-white hover:bg-white/10 hover:border-white/40 transition-all duration-300"
            >
              <Play className="h-4 w-4" />
              Fullservicepaket
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
